export function getPrimaryColorFilter() {
  const primaryColorFilter =
    'invert(59%) sepia(44%) saturate(3415%) hue-rotate(170deg) brightness(106%) contrast(105%)'
  return `brightness(0) invert(1) ${primaryColorFilter}`
}

export function getWhiteColorFilter() {
  return 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7490%) hue-rotate(227deg) brightness(102%) contrast(101%)'
}
